import PageNotFound from "@/components/PageNotFound"
import ProtectedRoute from "@/components/ProtectedRoute"
import SidebarLayout from "@/components/sidebar/SidebarLayout"
import AddPatientPage from "@/pages/add-patient/AddPatientPage"
import ForgotPasswordPage from "@/pages/auth/ForgotPasswordPage"
import LoginPage from "@/pages/auth/LoginPage"
import ResendInvitationSuccessPage from "@/pages/auth/ResendInvitationSuccessPage"
import ResetPasswordPage from "@/pages/auth/ResetPasswordPage"
import SignUpPage from "@/pages/auth/SignUpPage"
import VerifyCodePage from "@/pages/auth/VerifyCodePage"
import CustomerSupportPage from "@/pages/customer-support/CustomerSupportPage"
import PatientDetailPage from "@/pages/patient-details/PatientDetailPage"
import PatientListPage from "@/pages/patient-list/PatientListPage"
import PatientReadingsPage from "@/pages/patient-readings/PatientReadingsPage"
import { ROUTES } from "@/routes"
import { BrowserRouter, Navigate, Route, Routes } from "react-router"
import { Toaster } from "sonner"

// TODO: Move SidebarLayout so that it wraps multiple routes,
// instead of each route having its own SidebarLayout
const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={<Navigate to={ROUTES.POPULATION.ROOT} replace />}
        />
        <Route
          path={ROUTES.POPULATION.ROOT}
          element={
            <ProtectedRoute
              component={
                <SidebarLayout>
                  <PatientListPage />
                </SidebarLayout>
              }
            />
          }
        />
        <Route
          path={ROUTES.POPULATION.ADD_PATIENT}
          element={
            <ProtectedRoute
              component={
                <SidebarLayout>
                  <AddPatientPage />
                </SidebarLayout>
              }
            />
          }
        />
        <Route
          path={ROUTES.POPULATION.PATIENT_READINGS}
          element={
            <ProtectedRoute
              component={
                <SidebarLayout>
                  <PatientReadingsPage />
                </SidebarLayout>
              }
            />
          }
        />
        <Route
          path={ROUTES.POPULATION.PATIENT_DETAIL}
          element={
            <ProtectedRoute
              component={
                <SidebarLayout>
                  <PatientDetailPage />
                </SidebarLayout>
              }
            />
          }
        />
        <Route
          path={ROUTES.SUPPORT.ROOT}
          element={
            <ProtectedRoute
              component={
                <SidebarLayout>
                  <CustomerSupportPage />
                </SidebarLayout>
              }
            />
          }
        />
        <Route
          path={ROUTES.SUPPORT.PATIENT_DETAIL}
          element={
            <ProtectedRoute
              component={
                <SidebarLayout>
                  <PatientDetailPage />
                </SidebarLayout>
              }
            />
          }
        />

        <Route path={ROUTES.LOGIN} element={<LoginPage />} />
        <Route path={ROUTES.VERIFY_CODE} element={<VerifyCodePage />} />
        <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
        <Route path={ROUTES.RESET_PASSWORD} element={<ResetPasswordPage />} />
        <Route path={ROUTES.SIGN_UP} element={<SignUpPage />} />
        <Route
          path={ROUTES.RESEND_INVITATION_SUCCESS}
          element={<ResendInvitationSuccessPage />}
        />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
      <Toaster style={{ width: "500px" }} />
    </BrowserRouter>
  )
}

export default App
